import "./node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import apartmentsData from "./apartments_data.json";
import apartmentsData2 from "./apartments_data2.json";
import apartmentsData3 from "./apartments_data3.json";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

const placeholderURL =
  "https://fakeimg.pl/400x200?text=Apartamentul+nu+are+o+imagine&font=bebas&font_size=38";

document.addEventListener("DOMContentLoaded", function () {
  // Initialize Flatpickr for the filter date inputs
  flatpickr("#startDateFilter", {
    dateFormat: "d-m-Y",
    locale: "ro",
    onReady: function (selectedDates, dateStr, instance) {
      instance.input.placeholder = "Alege o dată";
    },
    onOpen: function (selectedDates, dateStr, instance) {
      instance.calendarContainer.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    },
  });
  flatpickr("#endDateFilter", {
    dateFormat: "d-m-Y",
    locale: "ro",
    onReady: function (selectedDates, dateStr, instance) {
      instance.input.placeholder = "Alege o dată";
    },
    onOpen: function (selectedDates, dateStr, instance) {
      instance.calendarContainer.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    },
  });

  const apartmentsContainer = document.getElementById("apartments-container");
  const paginationContainer = document.getElementById("pagination-container");
  const activeSortElement = document.getElementById("activeSort");
  let previousPageButton = document.getElementById("previous-page");
  let nextPageButton = document.getElementById("next-page");
  let currentPage = 1;
  let apartments = [];
  let originalApartments = [];
  let sortOption = "date-desc"; // Default sort option
  const rentalLink = document.getElementById("rental-link");
  const buyingLink = document.getElementById("buying-link");
  const houseLink = document.getElementById("houses-link");
  const startDateFilter = document.getElementById("startDateFilter");
  const endDateFilter = document.getElementById("endDateFilter");

  const priceRange = document.getElementById("priceRange");
  const priceMin = document.getElementById("priceMin");
  const priceMax = document.getElementById("priceMax");
  const sqmRange = document.getElementById("sqmRange");
  const sqmMin = document.getElementById("sqmMin");
  const sqmMax = document.getElementById("sqmMax");
  const applyFiltersButton = document.getElementById("applyFilters");
  const resetFiltersButton = document.getElementById("resetFilters");

  const searchInput = document.querySelector(".form-control[type='search']");
  const searchButton = document.querySelector(".btn[type='submit']");

  const currencyFilter = document.getElementById("currencyFilter");
  let selectedCurrency = "eur"; // Default currency
  let exchangeRate = 5; // Default exchange rate (fallback)

  async function fetchExchangeRate() {
    try {
      const response = await fetch(
        "https://api.exchangerate-api.com/v4/latest/EUR"
      ); // Example API
      if (!response.ok) {
        throw new Error("Failed to fetch exchange rate");
      }
      const data = await response.json();
      exchangeRate = data.rates.RON; // Update exchange rate for RON
      console.log(`Exchange rate updated: 1 EUR = ${exchangeRate} RON`);
    } catch (error) {
      console.error("Error fetching exchange rate:", error);
    }
  }

  // Call the function to fetch the exchange rate on page load
  fetchExchangeRate();

  function formatPrice(priceInEuros) {
    if (selectedCurrency === "ron") {
      return `${(priceInEuros * exchangeRate).toFixed(2)} Lei`; // Always show .00 for RON
    }
    return `${Math.round(priceInEuros)} €`; // No .00 for Euros
  }

  searchButton.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default form submission
    const searchTerm = searchInput.value.toLowerCase();
    apartments = originalApartments.filter((apartment) =>
      apartment.title.toLowerCase().includes(searchTerm)
    );
    currentPage = 1; // Reset to the first page
    renderPage();
  });

  let pageState = {
    rental: 1,
    buying: 1,
    houses: 1,
  };

  rentalLink.addEventListener("click", function (event) {
    event.preventDefault();
    currentPage = 1; // Reset to the first page
    setActiveLink(rentalLink);
    setPriceRangeMax(2000);
    loadApartmentsData("/apartments_data.json");
  });

  buyingLink.addEventListener("click", function (event) {
    event.preventDefault();
    currentPage = 1; // Reset to the first page
    setActiveLink(buyingLink);
    setPriceRangeMax(1000000);
    loadApartmentsData("/apartments_data2.json");
  });

  houseLink.addEventListener("click", function (event) {
    event.preventDefault();
    currentPage = 1; // Reset to the first page
    setActiveLink(houseLink);
    setPriceRangeMax(2000000);
    loadApartmentsData("/apartments_data3.json");
  });

  function setActiveLink(activeLink) {
    rentalLink.classList.remove("active");
    buyingLink.classList.remove("active");
    houseLink.classList.remove("active");
    activeLink.classList.add("active");
  }

  function loadApartmentsData(url) {
    let data;
    if (url === "/apartments_data.json") {
      data = apartmentsData;
    } else if (url === "/apartments_data2.json") {
      data = apartmentsData2;
    } else if (url === "/apartments_data3.json") {
      data = apartmentsData3;
    }
    // Filter apartments to only include those from Braila
    originalApartments = data.filter(
      (apartment) => apartment.date.split(" - ")[0].trim() === "Braila"
    ); // Store the filtered original data
    apartments = [...originalApartments]; // Reset apartments to the filtered dataset

    // Ensure currentPage is valid for the new dataset
    const totalPages = Math.ceil(
      apartments.length / (window.innerWidth < 768 ? 9 : 21)
    );
    if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    // Reset filters to default values
    resetFilters();

    const placeholderContainer = document.getElementById(
      "apartment-placeholders"
    );
    if (placeholderContainer) {
      placeholderContainer.classList.add("hidden");
      setTimeout(() => placeholderContainer.remove(), 50);
    }

    // Render the page with the filtered dataset without scrolling
    renderPage(false); // Pass `false` to prevent scrolling
  }

  document.querySelectorAll(".dropdown-item").forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      sortOption = this.getAttribute("data-sort");
      updateActiveSortText();
      renderPage(false); // Maintain scroll position
    });
  });

  function updateActiveSortText() {
    const sortTextMap = {
      "price-asc": "Preț (crescător)",
      "price-desc": "Preț (descrescător)",
      "date-asc": "Dată (crescător)",
      "date-desc": "Dată (descrescător)",
      "sqm-asc": "Metri pătrați (crescător)",
      "sqm-desc": "Metri pătrați (descrescător)",
    };
    activeSortElement.textContent = `Sortare activă: ${sortTextMap[sortOption]}`;
  }

  // Parses a raw date string from the data and returns a Date object.
  function parseApartmentDate(dateStr) {
    let text = dateStr.trim();
    if (/^(Reactualizat\s+)?Azi\s+(la\s+)?/i.test(text)) {
      text = text.replace(/^(Reactualizat\s+)?Azi\s+(la\s+)?/i, "");
      let today = new Date();
      let day = today.getDate();
      let monthRo = today.toLocaleString("ro-RO", { month: "long" });
      let year = today.getFullYear();
      text = `${day} ${monthRo} ${year} ${text}`;
    } else {
      text = text.replace(/^Reactualizat\s+la\s+/i, "");
    }

    const monthMapping = {
      ianuarie: "January",
      februarie: "February",
      martie: "March",
      aprilie: "April",
      mai: "May",
      iunie: "June",
      iulie: "July",
      august: "August",
      septembrie: "September",
      octombrie: "October",
      noiembrie: "November",
      decembrie: "December",
    };

    for (const [roMonth, enMonth] of Object.entries(monthMapping)) {
      let regex = new RegExp(roMonth, "i");
      if (regex.test(text)) {
        text = text.replace(regex, enMonth);
        break;
      }
    }

    let parsedDate = new Date(text);
    if (isNaN(parsedDate.getTime())) {
      parsedDate = new Date(0);
    }
    return parsedDate;
  }

  // Helper: parse a date string in "dd-mm-yyyy" format.
  function parseInputDate(dateStr) {
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return null;
  }

  function sortApartments(apartments) {
    let arr = [...apartments];
    if (sortOption === "date-asc" || sortOption === "date-desc") {
      arr.sort((a, b) => {
        const dateA = parseApartmentDate(a.date.split(" - ")[1] || a.date);
        const dateB = parseApartmentDate(b.date.split(" - ")[1] || b.date);
        return dateA - dateB;
      });
      if (sortOption === "date-desc") {
        arr.reverse();
      }
      return arr;
    } else if (sortOption === "price-asc" || sortOption === "price-desc") {
      arr.sort((a, b) => {
        const priceA = parseFloat(a.price.replace(/[^\d.-]/g, ""));
        const priceB = parseFloat(b.price.replace(/[^\d.-]/g, ""));
        return sortOption === "price-asc" ? priceA - priceB : priceB - priceA;
      });
      return arr;
    } else if (sortOption === "sqm-asc" || sortOption === "sqm-desc") {
      let valid = [];
      let unspecified = [];
      arr.forEach((apartment) => {
        if (apartment.sqm === "N/A") {
          unspecified.push(apartment);
        } else {
          valid.push(apartment);
        }
      });
      if (sortOption === "sqm-asc") {
        valid.sort((a, b) => parseFloat(a.sqm) - parseFloat(b.sqm));
      } else if (sortOption === "sqm-desc") {
        valid.sort((a, b) => parseFloat(b.sqm) - parseFloat(a.sqm));
      }
      return [...valid, ...unspecified];
    }
    return arr;
  }

  function isPlaceholderImage(imageUrl) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = function () {
        resolve(img.width === 500 && img.height === 500);
      };
      img.onerror = function () {
        resolve(false);
      };
      img.src = imageUrl;
    });
  }

  async function renderPage(scrollToTop = true) {
    let cardsPerPage;
    if (window.innerWidth < 768) {
      cardsPerPage = 9; // Phone: 9 cards per page
    } else if (window.innerWidth < 992) {
      cardsPerPage = 18; // Tablet: 18 cards per page
    } else {
      cardsPerPage = 27; // Computer: 27 cards per page
    }

    const uniqueApartments = [];
    const titles = new Set();
    for (const apartment of sortApartments(apartments)) {
      if (!titles.has(apartment.title)) {
        titles.add(apartment.title);
        uniqueApartments.push(apartment);
      }
    }
    const totalPages = Math.ceil(uniqueApartments.length / cardsPerPage);
    const start = (currentPage - 1) * cardsPerPage;
    const end = start + cardsPerPage;

    if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    const paginationY =
      paginationContainer.getBoundingClientRect().top + window.scrollY;

    if (uniqueApartments.length === 0) {
      apartmentsContainer.innerHTML = `
        <div class="col-12 text-center no-results-message">
          <p>Nu am găsit apartamente care să corespundă criteriilor tale. Încearcă să lărgești căutarea sau să actualizezi filtrele.</p>
        </div>
      `;
    } else {
      apartmentsContainer.innerHTML = await Promise.all(
        uniqueApartments.slice(start, end).map(async (apartment) => {
          const isNegotiable = apartment.price.includes("Prețul e negociabil");
          const priceInEuros = parseFloat(
            apartment.price.replace(/[^\d.-]/g, "")
          );
          const formattedPrice = formatPrice(priceInEuros);

          let originBadge = "";
          let link = apartment.link;
          if (link.includes("storia")) {
            originBadge =
              '<span class="badge bg-success position-absolute top-0 start-0 m-2">Storia</span>';
          } else if (link.includes("olx")) {
            originBadge =
              '<span class="badge bg-info position-absolute top-0 start-0 m-2">OLX</span>';
          }

          let imageUrl = apartment.image_url;
          if (await isPlaceholderImage(imageUrl)) {
            imageUrl = placeholderURL;
          } else if (imageUrl.startsWith("/app/static")) {
            imageUrl = placeholderURL;
          }

          return `
            <div class="col-md-6 col-lg-4 mb-4">
              <div class="card h-100 shadow-sm position-relative" onclick="window.open('${link}', '_blank')">
                ${originBadge}
                <img src="${imageUrl}" class="card-img-top img-fluid" alt="Apartment Image" style="object-fit: cover; height: 200px;">
                <div class="card-body d-flex flex-column">
                  <h5 class="card-title text-center">${apartment.title}</h5>
                  <p class="text-muted small text-center mb-2">${
                    apartment.date
                  }</p>
                  <div class="d-flex justify-content-between align-items-center mt-auto">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-houses icon-spacing"></i>
                      <span>${
                        apartment.sqm === "N/A"
                          ? "Nespecificat"
                          : `${apartment.sqm} m<sup>2</sup>`
                      }</span>
                    </div>
                    <span class="ms-2 fw-bold">${formattedPrice}</span>
                  </div>
                  ${
                    isNegotiable
                      ? '<span class="badge bg-warning position-absolute top-0 end-0 m-2">Negociabil</span>'
                      : ""
                  }
                </div>
              </div>
            </div>
          `;
        })
      ).then((htmlArray) => htmlArray.join(""));
    }

    renderPagination(totalPages);
    updatePaginationButtons(totalPages);

    if (scrollToTop) {
      window.scrollTo({ top: paginationY, behavior: "instant" });
    }
  }

  function renderPagination(totalPages) {
    const paginationItems = [];
    function createPageItem(page) {
      const pageItem = document.createElement("li");
      pageItem.classList.add("page-item");
      if (page === currentPage) {
        pageItem.classList.add("active");
      }
      const pageLink = document.createElement("a");
      pageLink.classList.add("page-link");
      pageLink.href = "#";
      pageLink.textContent = page;
      pageLink.addEventListener("click", function (event) {
        event.preventDefault();
        currentPage = page;
        renderPage();
      });
      pageItem.appendChild(pageLink);
      return pageItem;
    }
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        paginationItems.push(createPageItem(i));
      }
    } else {
      paginationItems.push(createPageItem(1));
      if (currentPage > 3) {
        paginationItems.push(createEllipsisItem(totalPages));
      }
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);
      for (let i = startPage; i <= endPage; i++) {
        paginationItems.push(createPageItem(i));
      }
      if (currentPage < totalPages - 2) {
        paginationItems.push(createEllipsisItem(totalPages));
      }
      paginationItems.push(createPageItem(totalPages));
    }
    const prevButton =
      paginationContainer.querySelector("#previous-page").parentElement;
    const nextButton =
      paginationContainer.querySelector("#next-page").parentElement;
    paginationContainer.innerHTML = "";
    paginationContainer.appendChild(prevButton);
    paginationItems.forEach((item) => paginationContainer.appendChild(item));
    paginationContainer.appendChild(nextButton);
  }

  function createEllipsisItem(totalPages) {
    const ellipsisItem = document.createElement("li");
    ellipsisItem.classList.add("page-item");
    const ellipsisLink = document.createElement("a");
    ellipsisLink.classList.add("page-link");
    ellipsisLink.href = "#";
    ellipsisLink.textContent = "•••";
    ellipsisLink.addEventListener("click", function (event) {
      event.preventDefault();
      const input = document.createElement("input");
      input.type = "number";
      input.classList.add("form-control", "form-control-sm");
      input.placeholder = "Pagina"; // Updated placeholder to Romanian
      input.style.width = "80px";
      input.style.webkitAppearance = "none";
      input.style.mozAppearance = "textfield";
      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          const page = parseInt(input.value, 10);
          if (!isNaN(page) && page >= 1 && page <= totalPages) {
            currentPage = page;
            renderPage();
          } else {
            input.classList.add("is-invalid");
          }
        }
      });
      input.addEventListener("blur", function () {
        ellipsisItem.innerHTML = "";
        ellipsisItem.appendChild(ellipsisLink);
      });
      ellipsisItem.innerHTML = "";
      ellipsisItem.appendChild(input);
      input.focus();
    });
    ellipsisItem.appendChild(ellipsisLink);
    return ellipsisItem;
  }

  function updatePaginationButtons(totalPages) {
    previousPageButton.disabled = false;
    nextPageButton.disabled = false;
    previousPageButton.replaceWith(previousPageButton.cloneNode(true));
    nextPageButton.replaceWith(nextPageButton.cloneNode(true));
    previousPageButton = document.getElementById("previous-page");
    nextPageButton = document.getElementById("next-page");
    previousPageButton.addEventListener("click", function (event) {
      event.preventDefault();
      currentPage = currentPage > 1 ? currentPage - 1 : totalPages;
      renderPage();
    });
    nextPageButton.addEventListener("click", function (event) {
      event.preventDefault();
      currentPage = currentPage < totalPages ? currentPage + 1 : 1;
      renderPage();
    });
  }

  window.addEventListener("resize", () => renderPage(false));
  updateActiveSortText(); // Initialize the active sort text

  // Set initial price range max based on default data load
  setPriceRangeMax(2000);
  resetFilters(); // Reset filters to default values
  loadApartmentsData("/apartments_data.json"); // Load rental data by default

  function setPriceRangeMax(maxValue) {
    priceRange.max = maxValue;
    priceMin.max = maxValue;
    priceMax.max = maxValue;
  }

  function resetFilters() {
    priceMin.value = 0;
    priceMax.value = priceRange.max;
    priceRange.value = priceRange.max;
    sqmMin.value = 0;
    sqmMax.value = sqmRange.max;
    sqmRange.value = sqmRange.max;
    startDateFilter.value = "";
    endDateFilter.value = "";
  }

  // Synchronize range sliders and text inputs
  priceRange.addEventListener("input", function () {
    priceMax.value = priceRange.value;
  });
  priceMin.addEventListener("input", function () {
    if (parseFloat(priceMin.value) > parseFloat(priceMax.value)) {
      priceMin.value = priceMax.value;
    }
  });
  priceMax.addEventListener("input", function () {
    priceRange.value = priceMax.value;
  });
  sqmRange.addEventListener("input", function () {
    sqmMax.value = sqmRange.value;
  });
  sqmMin.addEventListener("input", function () {
    if (parseFloat(sqmMin.value) > parseFloat(sqmMax.value)) {
      sqmMin.value = sqmMax.value;
    }
  });
  sqmMax.addEventListener("input", function () {
    sqmRange.value = sqmMax.value;
  });

  applyFiltersButton.addEventListener("click", function (event) {
    event.preventDefault();
    const priceMinValue = parseFloat(priceMin.value);
    const priceMaxValue = parseFloat(priceMax.value);
    const sqmMinValue = parseFloat(sqmMin.value);
    const sqmMaxValue = parseFloat(sqmRange.value);
    const startDateValue = startDateFilter.value;
    const endDateValue = endDateFilter.value;
    selectedCurrency = currencyFilter.value; // Update the selected currency
    applyFilters(
      priceMinValue,
      priceMaxValue,
      sqmMinValue,
      sqmMaxValue,
      startDateValue,
      endDateValue
    );
    event.stopPropagation();
    window.scrollTo({ top: 0, behavior: "instant" });
  });

  resetFiltersButton.addEventListener("click", function (event) {
    event.preventDefault();
    resetFilters();
    event.stopPropagation();
  });

  function applyFilters(
    priceMin,
    priceMax,
    sqmMin,
    sqmMax,
    startDate,
    endDate
  ) {
    apartments = originalApartments.filter((apartment) => {
      const apartmentPrice = parseFloat(
        apartment.price.replace(/[^\d.-]/g, "")
      );
      const apartmentSqm =
        apartment.sqm === "N/A" ? 0 : parseFloat(apartment.sqm);
      const apartmentDate = parseApartmentDate(
        apartment.date.split(" - ")[1] || apartment.date
      );

      const priceMatch =
        apartmentPrice >= priceMin && apartmentPrice <= priceMax;
      const sqmMatch = apartmentSqm >= sqmMin && apartmentSqm <= sqmMax;

      let dateMatch = true;
      if (startDate) {
        const parsedStart = parseInputDate(startDate);
        dateMatch = apartmentDate >= parsedStart;
      }
      if (endDate) {
        const parsedEnd = parseInputDate(endDate);
        dateMatch = dateMatch && apartmentDate <= parsedEnd;
      }

      const cityMatch = apartment.date.split(" - ")[0].trim() === "Braila";

      return priceMatch && sqmMatch && dateMatch && cityMatch;
    });
    currentPage = 1;
    renderPage();
  }
});
